import parseFilters from '@utils/parseFilters'
import parseQuery from '@utils/parseQuery'
import RestApiBuilder from '@utils/RestApiBuilder'
import { ApisauceInstance } from 'apisauce'
import _ from 'lodash'

/**
 * Expose all endponts for 'users'.
 * TODO: Talk with BE about this entity
 */
export default (api: ApisauceInstance): ApiObject => ({
  //...RestApiBuilder('users/tenant', api),
  // create: (data: object) => api.post(`register`, data),

  list: (page: number, size: number, filters?: FiltersUI, query?: object, sort?: string) => {
    return api.get(`users/global`, {
      page,
      ...(size && { size, }),
      ...(query && !_.isEmpty(query) && { filter: parseQuery(query), }),
      ...(sort && { sort, }),
      ...(filters && parseFilters(filters)),
    })
  },
  changePassword: (userLogin: string, currentPassword: string, newPassword: string, isAdminUser: boolean) => {
    //console.log(`change password api ${userLogin} ${newPassword}`)
    if (isAdminUser) {
      return api.post(`users/change-password`,
        {
          userLogin: userLogin,
          newPassword: newPassword
        }, {})
    }

    return api.post(`account/change-password`,
        {
          currentPassword: currentPassword,
          newPassword: newPassword
        }, {})
  },
})
